<rad-modal
#radModal
class="rad-theme--light"
identifier="radBaseModal"
[attr.closable]="closable"
[attr.dismissible]="dismissible"
[attr.heading]="title"
[attr.show-close-button]="showCloseButton" 
[attr.close-button-text]="closeButtonText"
[attr.show-confirm-button]="showConfirmButton"
[attr.confirm-button-text]="confirmButtonText"
[attr.show-new-button]="showNewButton"
[attr.new-button-text]="newButtonText"
[attr.disable-confirm-button]="disableConfirmButton"
layer-position="9001"
(onClose)="handleClose($event)"
(onNew)="handleNew($event)"
(onConfirm)="handleConfirm($event)"
(onDismiss)="handleClose($event)"
[appShadowDom]="shadowDomConfig"
>
    <ng-content></ng-content>
</rad-modal>

